<template>
    <div class="viso-chart-container" id="visoChart">
        <template v-for="item in data" v-if="item.type !== 'line'">
            <div :id="item.id" :class="['viso-chart-item',item.check ? 'active' : '']" :type="item.type">{{item.label}}</div>
        </template>
    </div>
</template>

<script>
    import services from "../../services/common.service"
    const visoConfig = {
        Endpoint: ['Dot', {
            radius: 1
        }],
        Connector: 'Flowchart',
        PaintStyle: {
            strokeStyle: '#9b9b9b',
            stroke: 'green',
            fillStyle: '#9b9b9b',
            radius: 6,
            lineWidth: 2
        },
        Anchors : [ "Left","Right"],
//        HoverPaintStyle: { stroke: 'blue' },
        MaxConnections: -1,
        ConnectionOverlays: [
            ['Arrow', {
                width: 10,
                length: 10,
                location: 1
            }]
        ]
    };
    export default {
        props:{
            serialNumber:String,
        },
        data() {
            return {
                jsPlumb:null,
                data:[],
                oBox:null,
                oParent:null,
            }
        },
        created() {

        },
        mounted() {
            this.jsPlumb = this.$jsPlumb.getInstance();
            this.$nextTick(() => {
                this.getData();
            });
            this.changeParanetWidth()
        },
        methods: {
            changeParanetWidth(){
                let sn=this.serialNumber
                if (sn.indexOf('Pro')>-1||sn.indexOf('Dep'>-1)){
                    this.oBox=document.getElementById('visoChart')
                    // console.log(this.oBox);
                    this.oParent=this.oBox.offsetParent
                    this.oParent.style.width='1500px'
                    // console.log(this.oParent);
                }
            },
            getData(){
                services.flowChart(this.serialNumber).then(res => {
                    this.data = res.list;
                    this.$nextTick(() => {
                        this.jsPlumb = this.$jsPlumb.getInstance();
                        this.$nextTick(() => {
                            this.jsPlumbInit()
                        })
                    })
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            jsPlumbInit() {
                const _this = this;
                this.jsPlumb.ready(function () {
                    // 导入默认配置
                    _this.jsPlumb.importDefaults({
                        ...visoConfig,
                        Container:_this.$el
                    });
                    // 会使整个jsPlumb立即重绘。
                    _this.jsPlumb.setSuspendDrawing(false,true);
                    _this.connect()
                })
            },
            connect(){
                this.data.forEach(item => {
                    if(item.type === 'line'){
                        this.jsPlumb.connect({
                            source: item.source,
                            target: item.target,
                            overlays: [
                                ['Label', {
                                    label: item.label,
                                    cssClass: "overlaysLabel",
                                }]
                            ],
                            paintStyle:{strokeWidth:2,stroke:'#9b9b9b',},
                            anchor: item.anchor || null
                        });
                    }
                });
                this.$nextTick(() => {
                    this.fn();
                })
            },
            empty(){
                this.jsPlumb.reset();
            },
            fn(){
                let arr = [];
                this.data.forEach((item,i) => {
                    if(item.type == 'line' && item.check){
                        arr.push(item)
                    }
                });
                arr.forEach(item => {
                    this.jsPlumb.connect({
                        source: item.source,
                        target: item.target,
                        overlays: [
                            ['Label', {label: item.label, cssClass: "overlaysLabel"}]
                        ],
                        paintStyle:{strokeWidth:2,stroke:'blue'},
                        anchor: item.anchor || null
                    });
                })

            }
        }
    }
</script>
<style>
    .overlaysLabel{
        background: white;
    }
</style>

<style lang="scss" scoped rel="stylesheet/scss">
    @import "~jsplumb/css/jsplumbtoolkit-defaults.css";
    .viso-chart-container{
        position: relative;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        font-size: 12px;
        min-height: 320px;
        align-items: center;
        .viso-chart-item{
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px;
            max-width:60px;
            height: 40px;
            border: 1.5px #9b9b9b solid;
            border-radius: 4px;
        }
        .active{
            border-color: blue;
        }
        .viso-chart-item[type=end],.viso-chart-item[type=start]{
            border-radius: 20px;
            width: 40px;
            height: 15px;
        }
    }
    .overlaysLabel{
        top:16px;
        color: red;
    }
</style>
